import React from 'react';
import PropTypes from 'prop-types';

import {
  STRING_FIELD_EDUCATION_SCHOOL,
} from '../labels';

import FormikLabeledField from './FormikLabeledField';

import formikPropTypes from './formikPropTypes';

export function SchoolField({
  name, formikProps,
}) {
  return (
    <FormikLabeledField
      name={name}
      formikProps={formikProps}
      label={STRING_FIELD_EDUCATION_SCHOOL}
      placeholder={STRING_FIELD_EDUCATION_SCHOOL}
    />
  );
}

SchoolField.propTypes = {
  name: PropTypes.string.isRequired,
  formikProps: formikPropTypes.isRequired,
};

export default SchoolField;
